module.exports = __webpack_public_path__ + "img/ID_Blue.11fac9b5.svg";